import React from 'react';
import {Button as BootstrapButton} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const Button = (props) => {
  let propsClass = props.className;
   let className =  `btn-primary ${props.size?props.size:'btn-lg'}`;
  return (
    <BootstrapButton
      {...props}
      className={propsClass?propsClass: className} disabled={props.disabled}>{
        props.label}
        {(props.showIcon && props.icon!==undefined) ?
        <>
          <span>   </span>
          <FontAwesomeIcon icon={props.icon} />

        </>
        :
            <>
            </>
        }
        
    </BootstrapButton>
  )
}